import { t } from '@lingui/macro';
import React, { FunctionComponent, useState } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';

import { ApiKeysTable } from './ApiKeysTable';
import { CreateApiKeyModal } from './modals';
import classes from './styles/api-keys-page.module.scss';

interface ApiKeysPageProps {
  organizationSlug: string;
  organizationKey: string;
  organizationName: string;
}

const ApiKeysPageContent: FunctionComponent<ApiKeysPageProps> = ({
  organizationSlug,
  organizationKey,
  // organizationName will be used for breadcrumbs/header in a future ticket
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [listRefreshKey, setListRefreshKey] = useState(0);

  return (
    <div className={classes.apiKeysPage}>
      <div className={classes.header}>
        <div className={classes.headerText}>
          <h1 className={classes.title}>{t`Integrations`}</h1>
          <p className={classes.description}>
            {t`Securely manage your secret API keys and client-side tokens.`}
            <br />
            {t`Quick heads up: Your API keys need updating by December 31, 2026.`}
            {' '}
            {t`We'll handle the transition smoothly if you update now.`}
          </p>
        </div>
        <button
          className={classes.createKeyButton}
          onClick={(): void => setIsCreateModalOpen(true)}
          type="button"
        >
          {t`Create New Key`}
        </button>
      </div>

      <div className={classes.tableContainer}>
        <ApiKeysTable
          listRefreshKey={listRefreshKey}
          organizationKey={organizationKey}
          organizationSlug={organizationSlug}
        />
      </div>

      <CreateApiKeyModal
        onCreated={(): void => setListRefreshKey((previous) => previous + 1)}
        open={isCreateModalOpen}
        organizationKey={organizationKey}
        setOpen={setIsCreateModalOpen}
      />
    </div>
  );
};

export const ApiKeysPage: FunctionComponent<ApiKeysPageProps> = ({
  organizationKey,
  organizationName,
  organizationSlug,
}) => (
  <I18nProviderWrapper>
    <ApiKeysPageContent
      organizationKey={organizationKey}
      organizationName={organizationName}
      organizationSlug={organizationSlug}
    />
  </I18nProviderWrapper>
);
